export const TIMELINE_BADGE_VARIANTS = {
  success: 'success',
  warning: 'warning',
  error: 'error',
} as const

export const TOOLTIP_VERTICAL_SPACING = 2
